export default __webpack_public_path__ + "static/media/book2.92b5d195.png";